<template>
  <div
    style="width: fit-content"
    class="rounded"
    :style="{
      backgroundColor: props.showBg ? state.model?.BgColor : '',
      padding: props.showBg ? '1px 10px' : '',
      color: state.model?.Color,
      fontSize: props.size + 'px',
    }"
  >
    {{ state.model?.Text || "-" }}
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import base from "@/utils/base";

export default {
  props: {
    arrName: String,
    showBg: {
      type: Boolean,
      default: () => false,
    },
    value: {
      type: Object,
    },
    size: {
      type: Number,
      default: 12,
    },
  },
  setup(props) {
    const state = reactive({
      model: {},
      rlzData: [],
      yrlData: [],
    });

    onMounted(() => {
      state.model = base[props.arrName].find((w) => w.Key == props.value);
    });

    return { props, state };
  },
};
</script>
<style lang="scss" scoped></style>
